import { Paper } from '@material-ui/core';
import styled from 'styled-components';

const BottomPaper = styled(Paper)`
  box-shadow: 0px -1px 1px -1px rgba(0, 0, 0, 0.2),
    0px -1px 1px 0px rgba(0, 0, 0, 0.14);
`;

export default BottomPaper;
